<div class="container">
  <div class="row">
    <div class="col-12 title">
      <img
        *ngIf="logoMobile"
        loading="lazy"
        [src]=logoMobile
        class="image"
        alt="logo"
        width="70"
        height="70"/>
      <h3>{{ 'COMMON.BAGS_VENDOR.TITLE' | translate : { shopName: shopName } }}</h3>
      <span class="close" (click)="close()">
        <svg-icon key="icon-close" class="image" aria-label="close"></svg-icon>
      </span>
    </div>
  </div>

  <div class="glovo-bags-vendor">
    <p class="glovo-bags-vendor__intro">
      {{ 'COMMON.BAGS_VENDOR.INTRO' | translate }}
    </p>
    <p class="glovo-bags-vendor__subintro">
      {{ 'COMMON.BAGS_VENDOR.SUBINTRO' | translate }}
    </p>
    <table class="glovo-bags-vendor__table table">
      <thead>
        <tr>
          <th scope="col">{{ 'COMMON.BAGS_VENDOR.TABLE_ADDRESS' | translate }}</th>
          <th scope="col">{{ 'COMMON.BAGS_VENDOR.TABLE_BAGS' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let subAccount of customer?.vendorSubAccounts?.subAccounts">
          <td>{{ subAccount.address }}</td>
          <td>{{ subAccount.procurementCreditsSf }}</td>
        </tr>
      </tbody>
      <tr class="glovo-bags__table-total">
        <td><strong>{{ 'COMMON.BAGS_VENDOR.TABLE_TOTAL' | translate }}</strong></td>
        <td><strong>{{ customer?.vendorSubAccounts?.totalProcurementCreditsSf }}</strong></td>
      </tr>
    </table>
    <p class="glovo-bags-vendor__footer mb-5" [innerHTML]="'COMMON.BAGS_VENDOR.FOOTER' | translate : { shopName: shopName }"></p>
  </div>
</div>
